<template>
    <div :class="['homepage-app', $_browserClass]" id="homepage-app">
        <PtHeader :service="headerService">
            <template #logo>
                <LogoPatSnap />
            </template>
            <template #hiroEntry>
                <HiroEntryButton
                    v-if="hiroAiModePermission"
                    mode="icon-label"
                    @click="handleHiroButtonClick"
                />
            </template>
            <template #timer>
                <PtHeaderWidgetCaseTime
                    :service="caseTimeService" />
            </template>
        </PtHeader>
        <router-view />
    </div>
</template>

<script>
import Bowser from 'bowser';
import headerMixin from './mixins/headerMixin';


export default {
    mixins: [
        headerMixin
    ],
    created() {
        // 获取浏览器相关class
        const browser = Bowser.getParser(window.navigator.userAgent);
        const { name, version } = browser.getBrowser();
        this.$_browserClass = [
            `browser-name--${name.replace(/ /g, '-').toLowerCase()}`,
            `browser-version--${parseInt(version, 10)}`,
            `browser-os--${browser.getOSName(true)}`
        ];
    }
};
</script>
